import React from 'react';
import { CommonErrorHelperTextV1 } from 'gemlux-common-components';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { styled as materialStyled } from '@mui/material/styles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { validation } from '../../../schema/validation';
import LogoIcon from '../../../assets/img/sidebar/logo.svg';

const CustomGridContainer = materialStyled(Grid)({
  maxWidth: '380px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid #DCE0E5',
  boxShadow: '0px 1px 2px 0px rgba(128, 128, 128, 0.12)',
  padding: '24px 20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
const CustomTextField = materialStyled(TextField)({
  paddingTop: '8px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
});
const CustomButton = materialStyled(Button)({
  backgroundColor: '#3348FF',
  borderRadius: '8px',
  padding: '12px 8px',
  '&:hover': {
    backgroundColor: '#007AFF',
  },
});

interface InputValidatorProps {
  handleSubmit: (_value: string) => void;
  error: boolean;
  errorText: string;
}

const InputValidator = ({ handleSubmit, error, errorText }: InputValidatorProps) => {
  const handleClick = (value: string) => {
    handleSubmit(value);
  };

  const formik = useFormik({
    initialValues: {
      subordinateOrganizationSignUp: '',
    },
    validationSchema: yup.object({
      subordinateOrganizationSignUp: validation.subordinateOrganizationSignUp,
    }),
    onSubmit: ({ subordinateOrganizationSignUp }) => {
      handleClick(subordinateOrganizationSignUp);
      formik.resetForm();
    },
    enableReinitialize: true,
  });

  return (
    <CustomGridContainer container gap="40px">
      <Grid item component="img" src={LogoIcon} />

      <Grid item xs={12} sm={12} display="flex" flexDirection="column" justifyContent="flex-start">
        <Grid item textAlign="center">
          <Typography variant="textBase500">Enter Your Company Name</Typography>
          <Grid item sx={{ mx: 'auto' }} xs={8} sm={8}>
            <CustomTextField
              sx={{ pb: '8px' }}
              type="text"
              name="subordinateOrganizationSignUp"
              aria-label="companyName"
              value={formik.values.subordinateOrganizationSignUp}
              onBlur={formik.handleBlur}
              variant="outlined"
              size="small"
              onChange={formik.handleChange}
              error={
                (formik.touched.subordinateOrganizationSignUp &&
                  Boolean(formik.errors.subordinateOrganizationSignUp)) ||
                error
              }
            />
            {error &&
              !(formik.touched.subordinateOrganizationSignUp && formik.errors.subordinateOrganizationSignUp) && (
                <CommonErrorHelperTextV1 errorText={errorText} />
              )}
            {formik.touched.subordinateOrganizationSignUp && formik.errors.subordinateOrganizationSignUp && (
              <CommonErrorHelperTextV1 errorText={formik.errors.subordinateOrganizationSignUp} />
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} display="flex" justifyContent="center">
        <CustomButton variant="contained" onClick={() => formik.handleSubmit()}>
          <Typography variant="textBase500">Continue</Typography>
        </CustomButton>
      </Grid>
    </CustomGridContainer>
  );
};

export default InputValidator;
